import { useCallback, useEffect, useRef } from 'react'

import { sendToApp } from '../utils/webViewBridge'

const useJwtToken = () => {
  const pendingPromises = useRef<
    Record<
      string,
      {
        promise: Promise<any>
        resolve: (value: any) => void
        reject: (reason?: any) => void
      }
    >
  >({})

  const sendMessage = useCallback(
    (payload: {
      type: string
      microAppID?: string
      value: string | number
    }) => {
      const { type } = payload

      if (!pendingPromises.current[type]) {
        let resolve!: (value: any) => void
        let reject!: (reason?: any) => void

        const promise = new Promise((res, rej) => {
          resolve = res
          reject = rej
        })

        // Timeout after 10s
        const timeout = setTimeout(() => {
          reject(new Error(`${type} request timed out`))
          delete pendingPromises.current[type]
        }, 10000)

        pendingPromises.current[type] = {
          promise,
          resolve: (data) => {
            clearTimeout(timeout)
            resolve(data)
            delete pendingPromises.current[type]
          },
          reject: (err) => {
            clearTimeout(timeout)
            reject(err)
            delete pendingPromises.current[type]
          },
        }

        sendToApp(payload)
      }

      return pendingPromises.current[type].promise
    },
    []
  )

  const getJwtToken = useCallback(() => {
    return sendMessage({ type: 'getJwtAuthToken', microAppID: 'ZETAPP' })
  }, [sendMessage])

  const refreshJwtToken = useCallback(() => {
    return sendMessage({ type: 'refreshJwtAuthToken', microAppID: 'ZETAPP' })
  }, [sendMessage])

  function isIOS() {
    return /iPad|iPhone|iPod/.test(window.navigator.userAgent)
  }

  useEffect(() => {
    window.sendJwtAuthToken = (data: any) => {
      pendingPromises.current['getJwtAuthToken']?.resolve(data)
    }

    getJwtToken()
  }, [getJwtToken])

  return { getJwtToken, refreshJwtToken, isIOS }
}

export { useJwtToken }
